import { axiosInstance, requestConfig } from 'network/apis';

import { URL_SYSTEM } from "utils/constants";

export const callCodeList = async (codeGroup) => {
    return await axiosInstance(requestConfig('get', URL_SYSTEM, `/code/${codeGroup}`));
};